var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.record)?_c('div',{staticClass:"record_detail"},[_c('record-panel',{attrs:{"record":_vm.record}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }